export const responsiveSplitter = (container: HTMLElement) => {
  // If the container is already expanded, do nothing
  if (container.classList.contains('expanded')) {
    return
  }
  let visibleChildren: (string | Element)[] = []

  // Functions
  const isItemOverflows = (item: Element) => {
    item.removeAttribute('hidden')
    const isOverflows =
      Math.floor(
        item.getBoundingClientRect().right -
          container.getBoundingClientRect().left
      ) > container.clientWidth
    item.setAttribute('hidden', '')
    return isOverflows
  }

  let toggle = container.querySelector('.toggle')
  if (!toggle) {
    toggle = document.createElement('span')
    toggle.classList.add('toggle')
    container.appendChild(toggle)

    toggle.addEventListener('click', () => {
      container.classList.toggle('expanded')
      if (container.classList.contains('expanded') && toggle) {
        for (const node of container.children) {
          node.removeAttribute('hidden')
        }
        toggle.textContent = '-'
      } else if (toggle) {
        initResponsiveCollapsed()
      }
    })
  }

  const initResponsiveCollapsed = () => {
    // initially hide all segments and the toggle
    for (const node of container.children) {
      node.setAttribute('hidden', '')
    }
    toggle.setAttribute('hidden', '')
    visibleChildren = []

    // show elements until the toggle overflows or all children remain visible
    for (const child of container.children) {
      if (child === toggle) {
        continue
      }
      if (isItemOverflows(child)) {
        break
      }
      child.removeAttribute('hidden')
      visibleChildren.push(child)
    }

    const childrenLength = container.children.length - 1 // Minus 1 to exclude the toggle
    if (visibleChildren.length < childrenLength) {
      toggle.textContent = `+${childrenLength - visibleChildren.length}`
      if (isItemOverflows(toggle)) {
        // hide the last visible segment if the toggle overflows
        ;(visibleChildren.pop() as Element | undefined)?.setAttribute(
          'hidden',
          ''
        )
      }
      toggle.removeAttribute('hidden')
    }
  }

  initResponsiveCollapsed()
  container.classList.add('split')
}

/** Items of a comma separated value (filters, URL search params), trimmed and without blanks */
export const splitList = (value?: string | null): string[] =>
  (value ?? '')
    .split(',')
    .map((entry) => entry.trim())
    .filter(Boolean)

/** Positive integer ids of a comma separated value, other entries ignored */
export const parseIdList = (value?: string | null): number[] =>
  splitList(value)
    .map((entry) => Number.parseInt(entry, 10))
    .filter((id) => Number.isInteger(id) && id > 0)

/** The list itself, or undefined when empty (optional API params) */
export const nonEmptyOrUndefined = <T>(list: T[]): T[] | undefined =>
  list.length > 0 ? list : undefined
